<script>
    import { add as addEvent, remove as removeEvent } from 'bianco.events';
    import { has as hasAttr, remove as removeAttr, set as setAttr } from 'bianco.attr';
    import $ from 'bianco.query';
    import { mapActions, mapState } from 'vuex';
    import { subscribe, unsubscribe } from 'util/misc/overlay-tracker';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import isDesktopMixin from 'framework/mixins/is-desktop';

    export default {
        mixins: [bemMixin('desktop-menu'), isDesktopMixin],
        computed: {
            ...mapState('desktop-menu', ['hasBigShadow']),
            ...mapState('header-search', {
                isHeaderSearchVisible: 'isVisible',
            }),
            rootClasses() {
                return [
                    this.bemIf(!this.isHeaderSearchVisible && this.hasBigShadow, 'big-shadow'),
                    this.bemIf(this.isHeaderSearchVisible, 'no-shadow'),
                ];
            },
        },
        methods: {
            getDetails() {
                return $('details', this.$el);
            },
            onClickOut(event) {
                const details = this.getDetails();
                const isClickInADetailsElement = details.some(d => d.contains(event.target));

                if (isClickInADetailsElement) {
                    return;
                }

                this.closeAllDetails();
            },
            closeAllDetails(details) {
                this.setMenuClosed();
                removeAttr(details || this.getDetails(), 'open');
            },
            onClick(event) {
                event.stopPropagation();

                // skip clicks on links
                if (event.target.tagName !== 'A') {
                    event.preventDefault();
                }

                if (hasAttr(event.target, 'open')) {
                    this.closeAllDetails();
                } else {
                    setAttr(event.currentTarget, 'open', 'open');
                    this.closeAllDetails(this.getDetails().filter(el => !el.contains(event.target)));
                    this.setMenuOpen();
                }
            },
            ...mapActions('desktop-menu', {
                setMenuOpen: 'open',
                setMenuClosed: 'close',
            }),
            ...mapActions('header-search', {
                toggleHeaderSearch: 'toggle',
            }),
        },
        watch: {
            isHeaderSearchVisible(value) {
                if (value) {
                    this.closeAllDetails();
                }
            },
        },
        mounted() {
            subscribe(this, this.closeAllDetails);
            addEvent(this.getDetails(), 'click', this.onClick);
            addEvent(window, 'click', this.onClickOut);
        },
        beforeDestroy() {
            unsubscribe(this);
            removeEvent(this.getDetails(), 'click', this.onClick);
            removeEvent(window, 'click', this.onClickOut);
        },
    };
</script>
